import React from 'react'
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube, } from "react-icons/fa"
import { images } from '../'

function Footer() {
    return (
        <div className="footer-section pt-5">
            <div className="pt-5 text-center">
                <div className="footer-logo">
                    <img src={images.logoWhite} alt="footer logo" className="img-fluid" />
                </div>
                <div className="footer-social py-4">
                    <a href="https://www.facebook.com/beecinc/" className="mx-3 mx-lg-4" target={'_blank'}>
                        <FaFacebookF color='white' size={'1.5em'} />
                    </a>
                    {/* <a href="https://twitter.com/beecinc" className="mx-3 mx-lg-4" target={'_blank'}>
                        <FaTwitter color='white' size={'1.5em'} />
                    </a> */}
                    {/* <a href="https://www.instagram.com/beecinc/" className="mx-3 mx-lg-4" target={'_blank'}>
                        <FaInstagram color='white' size={'1.5em'} />
                    </a> */}
                    <a href="https://www.linkedin.com/company/beec-inc/" className="mx-3 mx-lg-4" target={'_blank'}>
                        <FaLinkedinIn color='white' size={'1.5em'} />
                    </a>
                    <a href="https://www.youtube.com/channel/UCpdmYQFAYvPbqVRTS0FexIA/" className="mx-3 mx-lg-4" target={'_blank'}>
                        <FaYoutube color='white' size={'1.5em'} />
                    </a>
                </div>
                <div className="footer-contact mt-3">
                    <div className="row mx-0">
                        <div className="col-sm-6 col-md-3 py-4 ms-md-auto text-center side-border">
                            <div className="">
                                <p className="heading">VISIT US</p>
                                <p className="address mb-0">
                                    4125 Blackhawk Plaza Circle Suite 166 <br /> Danville, CA 94506
                                </p>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-3 py-4 me-md-auto text-center">
                            <div className="">
                                <p className="heading">Contact Us</p>
                                <p className="address mb-0">
                                    <a href="mailto:mail@beecadvantage.com" className="">mail@beecadvantage.com</a>
                                </p>
                                <p className="address mb-0">
                                    <a href="tel:(925) 557-1335" className="">(925) 557-1335</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-copyright">
                    <p className="copyright mb-0 py-3">
                        © 2022 BEEC Inc All Rights Reserved
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Footer